/*
 * Permissions management system, define access level for each of
 * your server apis, and restrict users by giving them access levels
 *
 * Copyright (C) 2020 Adam van der Kruk aka TacB0sS
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { HttpMethod } from '@nu-art/thunderstorm-shared';
import { Minute } from '@nu-art/ts-common';
export const _ApiDef_PermissionUser = {
    pah: {
        assignAppPermissions: { method: HttpMethod.POST, path: '/v1/permissions/assign/app-permissions' }
    }
};
export const ApiDef_PermissionsAssert = {
    vv1: {
        assertUserPermissions: { method: HttpMethod.POST, path: 'v1/permissions/assert-user-access' }
    }
};
export const ApiDef_Permissions = {
    v1: {
        // getUserUrlsPermissions: {method: HttpMethod.POST, path: 'v1/permissions/user-urls-permissions'},
        // getUserCFsByShareGroups: {method: HttpMethod.POST, path: 'v1/user-custom-fields/user-cf-by-share-groups'},
        // getUsersCFsByShareGroups: {method: HttpMethod.POST, path: 'v1/user-custom-fields/users-cf-by-share-groups'},
        // registerExternalProject: {method: HttpMethod.POST, path: 'v1/register/register-external-project'},
        // registerProject: {method: HttpMethod.GET, path: 'v1/register/register-project'},
        toggleStrictMode: { method: HttpMethod.GET, path: 'v1/permissions/toggle-strict-mode', timeout: Minute },
        createProject: { method: HttpMethod.GET, path: 'v1/permissions/create-first-project', timeout: Minute },
        // connectDomainToRoutes: {method: HttpMethod.POST, path: 'v1/permissions/connect-domain-to-routes'},
    }
};
//# sourceMappingURL=apis.js.map